import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { generalService } from '../../services/general.service';
import { DataService } from '../../utils/data.service';
import { modalComponent } from '../../utils/modal/modal.component';
import { MatDialog } from '@angular/material';
import { utils } from '../../utils/utils';
import { Nomina } from '../../models/nomina';
import { Http, Headers } from '@angular/http';

@Component({
  selector: 'my-generar-nomina',
  styles: [],
  templateUrl: './generar-nomina.component.html',
  providers: [generalService, utils]
})

export class generarNominaComponent implements OnInit {

  public headers = new Headers({'Content-Type': 'application/json; charset=utf-8', 'Accept': 'application/json, text/javascript, /;'});

  nominaGenerar: FormGroup;
  fechainicioVista:any;
  fechafinVista:any;
  public _utils:utils;
  public minDate:any;

  public usuarioSession: any;

  constructor(private formBuilder: FormBuilder, private _generalService: generalService, public dialog: MatDialog, public dataService: DataService, private _http: Http, private __utils: utils) { 
    this.dataService.guardado=false;
    this._utils = new utils();
    this.minDate = new Date(2000, 0, 1);
  }

  ngOnInit() {
      this.buildForm();
      this.dataService.mensajeAlert = "";
      // Get TPN Y DAY OF WEEK USUARIO EN SESION
      this.consultarUsuarioSesion();
      
      this.dataService.guardado=false;
  }

  consultarUsuarioSesion() {
      let usuario : any = {};
      usuario.loacs = sessionStorage.getItem('acslo');
      this._generalService.metodoCallParams(usuario, 'usuario/consultarUsuarioTipoPagoNomina/').subscribe(
          (result) => {
            if (result !== '') {
              this.usuarioSession = JSON.parse(result);
              if (this.usuarioSession.find(x => x.MEANING === 'Mensual') !== undefined) {
                const fechaActual = new Date();
                this.fechainicioVista = new Date(fechaActual.getFullYear(), fechaActual.getMonth(), 1);
                this.fechafinVista = new Date(fechaActual.getFullYear(), fechaActual.getMonth() + 1, 0);

              } else if (this.usuarioSession.find(x => x.MEANING === 'Semanal') !== undefined) {
                  // let dayOfWeek = this.usuarioSession.find(x => x.LOOKUP_TYPE === "DAY OF WEEK")[0]; // OBTIENE EL DIA DE LA SEMANA
                  let dayOfWeek = "Lunes";
                  for (let i = 0; i < this.usuarioSession.length; i++) {
                    if (this.usuarioSession[i].LOOKUP_TYPE == "DAY OF WEEK"){
                      dayOfWeek = this.usuarioSession[i].MEANING;
                      break;
                    }
                  }
                  switch(dayOfWeek) { // Dependiendo de su dia de paga
                    case 'Domingo':
                    this.fechafinVista = this.getNextDayOfWeek(new Date(), 0);
                    break;
                    case 'Lunes':
                    this.fechafinVista = this.getNextDayOfWeek(new Date(), 1);
                    break;
                    case 'Martes':
                    this.fechafinVista = this.getNextDayOfWeek(new Date(), 2);
                    break;
                    case 'Miércoles':
                    this.fechafinVista = this.getNextDayOfWeek(new Date(), 3);
                    break;
                    case 'Jueves':
                    this.fechafinVista = this.getNextDayOfWeek(new Date(), 4);
                    break;
                    case 'Viernes':
                    this.fechafinVista = this.getNextDayOfWeek(new Date(), 5);
                    break;
                    case 'Sábado':
                    this.fechafinVista = this.getNextDayOfWeek(new Date(), 6);

                    break;

                    default:
                      this.fechafinVista = this.getNextDayOfWeek(new Date(), 1);
                      break;

                  }
                  let date = new Date().setDate(this.fechafinVista.getDate() - 7);
                  this.fechainicioVista = new Date(date);

              } else if (this.usuarioSession.find(x => x.MEANING === 'Quincenal') !== undefined) {
                const fechaActual = new Date();
                if (fechaActual.getDate() >= 1 && fechaActual.getDate() <= 15) {
                  this.fechainicioVista = new Date(fechaActual.getFullYear(), fechaActual.getMonth(), 1);
                  this.fechafinVista = new Date(fechaActual.getFullYear(), fechaActual.getMonth(), 15);
                } else {
                  this.fechainicioVista = new Date(fechaActual.getFullYear(), fechaActual.getMonth(), 16);
                  this.fechafinVista = new Date(fechaActual.getFullYear(), fechaActual.getMonth()+1, 0);
                }

              } else if (this.usuarioSession.find(x => x.MEANING === 'Catorcenal') !== undefined) { // Duda
                const fechaActual = new Date();
                if (fechaActual.getDate() >= 1 && fechaActual.getDate() <= 14) {
                  this.fechainicioVista = new Date(fechaActual.getFullYear(), fechaActual.getMonth(), 1);
                  this.fechafinVista = new Date(fechaActual.getFullYear(), fechaActual.getMonth(), 14);
                } else {
                  this.fechainicioVista = new Date(fechaActual.getFullYear(), fechaActual.getMonth(), 15);
                  this.fechafinVista = new Date(fechaActual.getFullYear(), fechaActual.getMonth()+1, 0);
                }
              } else { // Si no tiene configuracion
                const fechaActual = new Date();
                if (fechaActual.getDate() >= 1 && fechaActual.getDate() <= 15) {
                  this.fechainicioVista = new Date(fechaActual.getFullYear(), fechaActual.getMonth(), 1);
                  this.fechafinVista = new Date(fechaActual.getFullYear(), fechaActual.getMonth(), 15);
                } else {
                  this.fechainicioVista = new Date(fechaActual.getFullYear(), fechaActual.getMonth(), 16);
                  this.fechafinVista = new Date(fechaActual.getFullYear(), fechaActual.getMonth()+1, 0);
                }
              }

              // this.dataService.mensajeAlert = result;
            }
          },
          (error) => {
            var errorMsj = <any>error;
            console.log(errorMsj);
          }
      );
  }

   getNextDayOfWeek(date, dayOfWeek) {

    let resultDate = new Date(date.getTime());

    resultDate.setDate(date.getDate() + (7 + dayOfWeek - date.getDay()) % 7);

    return resultDate;
}

  buildForm() {
    this.nominaGenerar = this.formBuilder.group({
      fechainicio: this.formBuilder.control(null, [Validators.required, Validators.minLength(10), Validators.maxLength(11)]),
      fechafin: this.formBuilder.control(null, [Validators.required, Validators.minLength(10), Validators.maxLength(11)]),
    });
  }

  cerrarModal(){
    this.dataService.dialogRef.close();
  }

  onSubmit() {  

      let nominaVar = new Nomina();
      

      let fechaI = this._utils.changeFormatDate(this.fechainicioVista._d || this.fechainicioVista, "yyyy-mm-dd");
      let fechaF = this._utils.changeFormatDate(this.fechafinVista._d || this.fechafinVista, "yyyy-mm-dd");

      nominaVar.loacs = sessionStorage.getItem('acslo');
      nominaVar.fechaInicio = fechaI;
      nominaVar.fechaFin = fechaF;

      let regx = /^\d{4}-(0?[1-9]|1[012])-(0?[1-9]|[12][0-9]|3[01])$/;
      if(!regx.test(fechaI) )
      {
          this.modal("alert", "La fecha de inicio no tiene el formato correcto (día/mes/año)");
      }
      else if(!regx.test(fechaF) )
      {
          this.modal("alert", "La fecha de fin no tiene el formato correcto (día/mes/año)");
      }
      else{
      const json = JSON.stringify(nominaVar);
      const params = json;
        this._http.post(`${this.__utils.url}nomina/generarNomina/`,params, {headers: this.headers}).subscribe(
            result => {
              if(result.json() == ''){
                this.dataService.guardado=true;
                this.cerrarModal();
              }
              else{
                this.modal("alert", result.json());
              }              
            },
            error => {
              var errorMsj = <any>error;
              console.log(errorMsj);
            }
        ); 
      }

  }


  modal(tipo, mensaje){
    this.dataService.modal = tipo;
    this.dataService.mensaje = mensaje;
    const dialogModal = this.dialog.open(modalComponent, {disableClose: true});
    this.dataService.dialogModal = dialogModal;
  }

}



// WEBPACK FOOTER //
// ./src/app/nomina/generarNomina/generar-nomina.component.ts